import api from './axios';

export const login = (data) => api.post('/api/auth/login', data);
export const getMe = () => api.get('/api/auth/me');

export const getStudents = () => api.get('/api/admin/students');
export const createStudent = (data) => api.post('/api/admin/students', data);
export const updateStudent = (id, data) => api.put(`/api/admin/students/${id}`, data);
export const deleteStudent = (id) => api.delete(`/api/admin/students/${id}`);
export const getStudentTests = (studentId) => api.get(`/api/admin/students/${studentId}/tests`);

export const getSubjects = () => api.get('/api/subjects');
export const createSubject = (data) => api.post('/api/subjects', data);
export const getChapters = (subjectId) => api.get(`/api/subjects/${subjectId}/chapters`);
export const createChapter = (subjectId, data) => api.post(`/api/subjects/${subjectId}/chapters`, data);
export const getTopics = (chapterId) => api.get(`/api/chapters/${chapterId}/topics`);
export const createTopic = (chapterId, data) => api.post(`/api/chapters/${chapterId}/topics`, data);

export const getQuestions = (params) => api.get('/api/questions', { params });
export const createQuestion = (data) => api.post('/api/questions', data);
export const updateQuestion = (id, data) => api.put(`/api/questions/${id}`, data);
export const deleteQuestion = (id) => api.delete(`/api/questions/${id}`);

export const createTest = (data) => api.post('/api/tests', data);
export const getTests = () => api.get('/api/tests');
export const getTest = (id) => api.get(`/api/tests/${id}`);
export const submitTest = (id, data) => api.post(`/api/tests/${id}/submit`, data);
export const getResult = (id) => api.get(`/api/tests/${id}/result`);
export const getAdminResult = (id) => api.get(`/api/tests/${id}/admin-result`);

export const getVideos = (chapterId) => api.get('/api/videos', { params: { chapter_id: chapterId } });
export const createVideo = (data) => api.post('/api/videos', data);
export const updateVideo = (id, data) => api.put(`/api/videos/${id}`, data);
export const deleteVideo = (id) => api.delete(`/api/videos/${id}`);
export const reorderVideos = (data) => api.patch('/api/videos/reorder', data);

export const getCards = (chapterId) => api.get('/api/cards', { params: { chapter_id: chapterId } });
export const createCard = (data) => api.post('/api/cards', data);
export const updateCard = (id, data) => api.put(`/api/cards/${id}`, data);
export const deleteCard = (id) => api.delete(`/api/cards/${id}`);
export const getPracticeCards = () => api.get('/api/cards/practice');
export const attemptCard = (id, data) => api.post(`/api/cards/${id}/attempt`, data);
export const getCardPreferences = () => api.get('/api/cards/preferences');
export const updateCardPreferences = (data) => api.put('/api/cards/preferences', data);

export const unlockAttempt = (testId, questionId, data) => api.post(`/api/tests/${testId}/questions/${questionId}/unlock-attempt`, data);
export const retireQuestion = (testId, questionId) => api.post(`/api/tests/${testId}/questions/${questionId}/retire`);
export const unretireQuestion = (testId, questionId) => api.delete(`/api/tests/${testId}/questions/${questionId}/retire`);
export const getRetiredCount = () => api.get('/api/tests/retired/count');
export const flagQuestionError = (questionId) => api.post(`/api/questions/${questionId}/flag-error`);

export const generateExplanation = (questionId) => api.post(`/api/questions/${questionId}/generate-explanation`);
export const listManualReviews = () => api.get('/api/admin/manual-reviews');
export const resolveManualReview = (questionId, data) => api.post(`/api/admin/manual-reviews/${questionId}/resolve`, data);

export const lookupQuestions = (data) => api.post('/api/admin/questions/lookup', data);
